import React from 'react';
import { Button } from 'devextreme-react';
import { usePushNotificationContext } from '../../contexts/pushNotifications';
import './NotificationBadge.scss';

const NotificationBadge = ({ onClick, showText = false }) => {
  const { unreadCount } = usePushNotificationContext();

  return (
    <div className="notification-badge-container">
      <Button
        icon="bell"
        stylingMode="text"
        onClick={onClick}
        className="notification-button"
        hint="Benachrichtigungen"
      >
        {showText && "Benachrichtigungen"}
      </Button>
      {unreadCount > 0 && (
        <span className="notification-count-badge">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </div>
  );
};

export default NotificationBadge;
